import TimeRangeType from 'types/TimeRangeType';
import useNavigation from './useNavigation';

interface IParams {
  start_date?: string;
  end_date?: string;
  time_range_type?: TimeRangeType;
}

export default function useGPSDisabledNavigation() {
  return useNavigation<IParams>('/gps-disabled-report');
}
